import React, { useEffect } from "react";
import { FaArrowLeft, FaTimes } from "react-icons/fa";

const AdminModalShell = ({ isOpen, onClose, isDarkMode, children, maxWidth = "max-w-3xl", pageMode = false }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  if (pageMode) {
    return (
      <div className={isDarkMode ? "fixed bottom-[4.25rem] left-0 right-0 top-[4.5rem] z-30 overflow-y-auto bg-slate-950 px-4 py-8 text-slate-100 lg:left-[248px] sm:px-6 lg:px-10" : "fixed bottom-[4.25rem] left-0 right-0 top-[4.5rem] z-30 overflow-y-auto bg-slate-50 px-4 py-8 text-slate-900 lg:left-[248px] sm:px-6 lg:px-10"}>
        <div className={`mx-auto ${maxWidth}`}>
          <button type="button" onClick={onClose} className={`mb-6 inline-flex items-center gap-2 text-sm font-bold transition ${isDarkMode ? "text-emerald-300 hover:text-emerald-200" : "text-emerald-700 hover:text-emerald-800"}`}><FaArrowLeft /> Back</button>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/60 p-4 backdrop-blur-sm">
      <button type="button" className="absolute inset-0" onClick={onClose} aria-label="Close form" />
      <div className={`relative w-full ${maxWidth} max-h-[90vh] overflow-y-auto rounded-[1.75rem] border ${isDarkMode ? "border-slate-800 bg-slate-950" : "border-slate-200 bg-white"}`}>
        <button
          type="button"
          onClick={onClose}
          className={`absolute right-4 top-4 z-10 inline-flex h-10 w-10 items-center justify-center rounded-full border transition ${isDarkMode ? "border-slate-700 bg-slate-900 text-slate-300 hover:bg-slate-800" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}
          aria-label="Close form"
        >
          <FaTimes />
        </button>
        {children}
      </div>
    </div>
  );
};

export default AdminModalShell;
